const cookie_set = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const urlParams = searchParams.get('index');
  const cookie_shop_code = Cookies.get('shop_code');

  if (urlParams == 'women') {
    Cookies.set('shop_code', 'AOGL-LADIES', { expires: 7 });
  } else if (urlParams == 'men') {
    Cookies.set('shop_code', 'AOGL-MENS', { expires: 7 });
  } else if (cookie_shop_code == 'AOGL-LADIES') {
    Cookies.set('shop_code', 'AOGL-LADIES', { expires: 7 });
  } else if (cookie_shop_code == 'AOGL-MENS') {
    Cookies.set('shop_code', 'AOGL-MENS', { expires: 7 });
  } else {
    Cookies.set('shop_code', 'AOGL-MENS', { expires: 7 });
  }
  const current_cookie_shop_code = Cookies.get('shop_code');
}

const show_mw_func = (text) => {
  document.querySelectorAll(`[data-change-mw]`).forEach(value => value.style.display = 'none')
  document.querySelectorAll(`[data-change-mw="${text}"]`).forEach(value => value.style.display = 'block')
}

const display_mw_func = () => {
  const shop_code = Cookies.get('shop_code');
  if (shop_code == 'AOGL-MENS') {
    show_mw_func('men')
  } else if (shop_code == 'AOGL-LADIES') {
    show_mw_func('women')
  }
}

window.addEventListener('DOMContentLoaded', function () {
  cookie_set()
  display_mw_func()
  setTimeout(() => {
    display_mw_func()
  }, 500);
  setTimeout(() => {
    display_mw_func()
  }, 1000);
  document.querySelector('body').classList.add('loaded')
})